import * as externalApiWS from '../webservices/externalApiWS';
import { QUESTIONAIRE_EDIT_ACTION } from './questionaireActions';

export const TOGGLE_QUESTIONNAIRE_API_REQUEST = 'TOGGLE_QUESTIONNAIRE_API_REQUEST';
export const TOGGLE_QUESTIONNAIRE_API_SUCCESS = 'TOGGLE_QUESTIONNAIRE_API_SUCCESS';
export const TOGGLE_QUESTIONNAIRE_API_FAILURE = 'TOGGLE_QUESTIONNAIRE_API_FAILURE';

export const FETCH_TENANT_TOKEN_REQUEST = 'FETCH_TENANT_TOKEN_REQUEST';
export const FETCH_TENANT_TOKEN_SUCCESS = 'FETCH_TENANT_TOKEN_SUCCESS';
export const FETCH_TENANT_TOKEN_FAILURE = 'FETCH_TENANT_TOKEN_FAILURE';

export const REGENERATE_TENANT_TOKEN_REQUEST = 'REGENERATE_TENANT_TOKEN_REQUEST';
export const REGENERATE_TENANT_TOKEN_SUCCESS = 'REGENERATE_TENANT_TOKEN_SUCCESS';
export const REGENERATE_TENANT_TOKEN_FAILURE = 'REGENERATE_TENANT_TOKEN_FAILURE';

export const toggleQuestionnaireApiAccess = (questionnaireId, tenantId, enabled, questionnaire) => async (dispatch, getState) => {
    dispatch({ type: TOGGLE_QUESTIONNAIRE_API_REQUEST });
    try {
        const response = await externalApiWS.toggleQuestionnaireApiAccess(questionnaireId, tenantId, enabled, getState);
        dispatch({
            type: TOGGLE_QUESTIONNAIRE_API_SUCCESS,
            payload: { questionnaireId, ...response }
        });
        // Update the questionnaire in Redux store so it persists across re-renders
        if (questionnaire) {
            dispatch({
                type: QUESTIONAIRE_EDIT_ACTION,
                payload: {
                    ...questionnaire,
                    externalApiEnabled: enabled,
                    externalApiToken: response.token,
                    externalApiTokenCreatedAt: response.createdAt
                }
            });
        }
        return response;
    } catch (error) {
        dispatch({ type: TOGGLE_QUESTIONNAIRE_API_FAILURE, payload: error.message });
        throw error;
    }
};

export const fetchTenantApiToken = () => async (dispatch, getState) => {
    dispatch({ type: FETCH_TENANT_TOKEN_REQUEST });
    try {
        const response = await externalApiWS.getTenantApiToken(getState);
        dispatch({ type: FETCH_TENANT_TOKEN_SUCCESS, payload: response });
        return response;
    } catch (error) {
        dispatch({ type: FETCH_TENANT_TOKEN_FAILURE, payload: error.message });
        throw error;
    }
};

export const regenerateTenantApiToken = () => async (dispatch, getState) => {
    dispatch({ type: REGENERATE_TENANT_TOKEN_REQUEST });
    try {
        const response = await externalApiWS.regenerateTenantToken(getState);
        dispatch({ type: REGENERATE_TENANT_TOKEN_SUCCESS, payload: response });
        return response;
    } catch (error) {
        dispatch({ type: REGENERATE_TENANT_TOKEN_FAILURE, payload: error.message });
        throw error;
    }
};
